import React from 'react';
var defaultValue = {
  IsTrial: false,
  TrialExpired: false,
  AllowTrial: false,
  RemainingDays: 0
};
var LicensingContext = React.createContext(defaultValue);
export default LicensingContext;